module.exports = __webpack_public_path__ + "img/logo.61ff9039.png";